import React from "react";
import "./CardRight.css";

type CardProps = {
  title?: string;
  children?: React.ReactNode;
};

export default function Card_right({ title, children }: CardProps) {
  return (
    <div className="card-right">
      {title && <h3 className="card-right-title">{title}</h3>}
      <div className="card-right-content">{children}</div>
    </div>
  );
}
